// @flow
import React, { createContext, useContext, useState, useEffect } from 'react';
import type { Node } from 'react';
import Debug from 'debug';
import { useMap } from '../../ui/openlayers';

const debug = Debug('amms:modules:map:targets');

type Context = $ReadOnly<{
    baseResolution: number
}>;

const StyleContext = createContext<Context>({});

const useResolutionForZoom = (zoom: number) => {
    const [resolution, setResolution] = useState(1);
    const map = useMap();

    useEffect(() => {
        if(map) {
            const view = map.getView();

            if(view) {
                const _resolution = map.getView().getResolutionForZoom(zoom);
                debug(`Getting resolution for zoom level ${zoom}: ${_resolution}`);
                setResolution(_resolution);
            }
        }
    }, [map, zoom]);

    return resolution;
};

type Props = $ReadOnly<{
    baseZoom: number,
    children: Node
}>;

export const StyleProvider = ({ baseZoom, labelConfig, children }: Props) => {
    const baseResolution = useResolutionForZoom(baseZoom);

    const context = {
        baseResolution,
        labelConfig
    };

    return (
        <StyleContext.Provider value={context}>
            {children}
        </StyleContext.Provider>
    );
};

export const useStyleContext = () => useContext(StyleContext);

export const useBaseResolution = () => {
    const context = useStyleContext();
    return context.baseResolution;
};

export const useLabelConfig = () => {
    const context = useStyleContext();
    return context.labelConfig;
};

